import { SearchIcon } from "lucide-react";

import { Input } from "~/components/ui/input";

export function Search() {
  return (
    <div className="relative">
      <SearchIcon className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
      <Input
        type="search"
        placeholder="Buscar..."
        className="w-[200px] pl-8 md:w-[300px]"
      />
    </div>
  );
}
